var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-import-success"},[_c('CustomerImportInSuccess',{attrs:{"totalCustomersToImport":_vm.customerImportData.total,"customerImportData":_vm.stepProps},on:{"completed":_vm.handleCompleted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }